import React, { useContext, useEffect, useState } from 'react';
import { Typography, Button, MessageBox } from '@ajaibid/components';
import { Form, FormContext } from 'Component/FormV2';
import { V4 } from 'Util/fetcher';
import PopupEmailSupport from 'Component/PopUp/PopUpEmailSupport';
import { Loader } from 'Component/Loader';
import { PinContext } from './context';

const IMGKTP = require('Image/img-ktp-new.png');

export const PinResetSecurity = () => {
  const [, { getField }] = useContext(FormContext);
  const { forgetPinFlex, idNumber, errorMessage, errorCode, isLoadingPin } = useContext(PinContext);
  const [nikValue, setNikValue] = useState('');
  const [error, setError] = useState('');
  const [showEmailSupport, setShowEmailSupport] = useState(false);

  useEffect(() => {
    setNikValue(idNumber);
    setError(errorMessage);
  }, [errorMessage, errorCode, idNumber]);

  useEffect(() => {
    if (getField('nik').value) {
      if (getField('nik').value !== nikValue) {
        setError('');
      }
    }
  }, [getField]);

  const handleSubmitForgot = () => {
    forgetPinFlex({ id_number: getField('nik').value }, V4);
  };

  return (
    <div>
      <PopupEmailSupport
        setIsShowPopup={() => setShowEmailSupport(false)}
        isShowPopup={showEmailSupport}
        emailSupport={{
          mutual_fund: 'support.reksadana@ajaib.co.id',
          stock: 'support.saham@ajaib.co.id',
        }}
      />
      <img src={IMGKTP} alt="..." />
      <Typography
        type="heading"
        size="sm"
        bold
        style={{ marginTop: '40px' }}
        data-testid="forgot-pin-success"
      >
        Masukkan NIK
      </Typography>
      <Typography type="body" size="lg" style={{ marginTop: '16px' }}>
        Masukkan NIK sesuai dengan KTP yang telah terdaftar di akun Ajaib kamu.
      </Typography>
      <div className="mb-40">
        <Form.Text
          name="nik"
          id="nik"
          block
          maxLength="16"
          error={error}
          defaultValue={nikValue}
          validators={{
            required: {
              validator: (v) => Number.isInteger(Number(v)) && v !== '',
              message: 'NIK harus 16 angka. Coba periksa lagi, ya.',
            },
            max: {
              validator: (v) => v.length <= 16,
              message: 'NIK harus 16 angka. Coba periksa lagi, ya.',
            },
            min: {
              validator: (v) => v.length >= 16,
              message: 'NIK harus 16 angka. Coba periksa lagi, ya.',
            },
          }}
        />
        {errorCode && errorCode !== 'EC0001002' && (
          <MessageBox
            type="info"
            style={{ marginTop: 12 }}
            text="Butuh bantuan lebih lanjut? Tim Ajaib akan siap membantu kamu."
            actions={[{ text: 'Hubungi Bantuan Ajaib', onClick: () => setShowEmailSupport(true) }]}
          />
        )}
        {errorCode && errorCode === 'EC0001002' && (
          <MessageBox
            type="caution"
            style={{ marginTop: 12 }}
            text={errorMessage}
            actions={[{ text: 'Hubungi Bantuan Ajaib', onClick: () => setShowEmailSupport(true) }]}
          />
        )}
      </div>
      {isLoadingPin ? (
        <Loader />
      ) : (
        <Button
          fluid
          size="lg"
          disabled={getField('nik').value === '' || getField('nik').error !== false}
          onClick={handleSubmitForgot}
        >
          Kirim
        </Button>
      )}
    </div>
  );
};
